import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import MenuTable from "../../helpers/MenuTable";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputTextArea from "../../helpers/InputTextArea";
import InputCombo from "../../helpers/InputCombo";



export default function Mets(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);



       const [errTab, setErrTab] = useState([]);  //z info od serwera..  
       const [row, setRowX] = useState({
          men_dziennik_id: props.id,
          dzien: '',
          godzina: '08:00',
          godzina_do: '09:00',
          tytul: '',
          opis: '',

          
          info_wall: 0,
          info_wall_text: "Szanowni Państwo, dnia .... odbędzie się zebranie rodziców....",
       });


 
    const [filterParam, setFilterParam] = useState({  

        men_dziennik_id: props.id,
        dzien: '',
         
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);



       const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    


          const valChangeListenerRow = (filedName, val, correct, msg) => {         
             console.log("valChangeListenerRow: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
            
                         
         
             setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );              
        }  

    
    const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );

             if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
           

            props.mainView.writeFilter(filedName, val);
        }

    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

            
      const filterClear = () => {
 
 
       
            setFilterParam({
 
               men_dziennik_id: props.id,
               dzien: '',                
                        

                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },


                limit: 50,
                page: 1,
                show: true, 
            });
            setTab(null);
        }
        


 const filterApprove = () => {   
     setTab(null)     
 }


 
    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    const changeView = (e ) => {

        setRowX({
          men_dziennik_id: props.id,
          dzien: '',
          godzina: '08:00',
          godzina_do: '09:00',
          tytul: '',
          opis: '',
                    
          info_wall: 0,
          info_wall_text: "Szanowni Państwo, dnia .... odbędzie się zebranie rodziców....",
       });
        
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
        }



 
    const getTab = () => {
            
        
            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,mets', {
                method: 'POST', 
                body: JSON.stringify(filterParam), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);             

                            if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }



        const deleteRecord = (e) => {

                var id = e.target.getAttribute("id");
                props.mainView.showDialog( "Pytanie", "Na pewno chcesz usunąć wpis?" , "yesno" ,  (param) => {
                        
                            if(param == "yes")
                            {
                            deleteRecordYes(id)
                            }
                    } );
}

       const deleteRecordYes = (id)  => {

            
            var req = {
                id: id
            };

            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,met_remove', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {       
                            getTab();                                                         
                            props.mainView.showDialog( "Sukces", "Wpis został usunięty" , "ok" , (param)=>{
                                   getTab();                          
                            } );  
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;

        }


           const saveData = () => {

 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        
            if(row.opis.length < 10)
            {
                 props.mainView.showDialog( "Error", "Podaj opis, min. 10 znaków." , "ok" , null);  
                 return;
            }

            if(row.dzien.length < 4 || row.dzien == '0000-00-00')
            {
                 props.mainView.showDialog( "Error", "Wskaż dzień spotkania z rodzicami." , "ok" , null);  
                 return;
            }

    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_men,met_add', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            setView({v:'list',id:-1});
                            props.mainView.showDialog( "Sukces",  "Informacje zostały zapisane.", "ok" , null);                        
                            getTab();
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }




   if(tab == null)
   {
      setTab([]);
      getTab(); 
      return <div>...</div>
   }

   
   var itemsTakNie = [
    {v: 0,title:'Nie'},
    {v: 1,title:'Tak'},
   ];


    var viewDialog = null;

    if(view.v == "new")
    {
                viewDialog =   <div className="dlg_window dlg_type_xx shadowx">
            
                                    <div className="dlg_title">
                                        Nowe spotkanie z rodzicami
                                    </div>

                                    <div className="dlg_content_x scroll500">

                                              <div className="form_tab">
                                                
                                                                    
                                                            <div className="form_control">
                                                                <div className="fieldName">Dzień*</div>
                                                                <InputDate   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="dzien" placeholder={":"} className='   ' req='1' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Od godziny*</div>
                                                                <InputTime   userData={props.userData} value={row.godzina} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="godzina" placeholder={":"} className='   ' req='1' firstUp="0" />
                                                            </div>
 

                                                            <div className="form_split"></div>


                                                            <div className="form_control">
                                                                <div className="fieldName">Nazwa (np. Podsumownie półrocza)*</div>
                                                                <InputText   userData={props.userData} value={row.tytul} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="tytul" placeholder={"Nazwa: np. Wyczieczka do ZOO"} className=' w300 ' req='1' firstUp="0" />
                                                            </div>


                                                            <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Opis (co zostanie omówione na spotkaniu)*</div>
                                                                <InputTextArea   userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="opis" placeholder={"Opis:"} className=' w400  h100' req='1' firstUp="0" />
                                                            </div>

                                              </div>



                                            <div className="form_tab">

                                                            <div className="form_control">
                                                                <div className="fieldName">Dodać informacje w aktualnościach?</div>
                                                                <InputCombo items={itemsTakNie}   userData={props.userData} value={row.info_wall} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="info_wall" placeholder={""} className='   ' req='1' firstUp="0" />
                                                            </div>

                                                            {
                                                                row.info_wall == 1&& 
                                                                <Fragment>                         
                                                                     <div className="form_split"></div>                                           
                                                                     <div className="form_control">                                                                           
                                                                            <div className="fieldName">Informacja*</div>
                                                                            <InputTextArea   userData={props.userData} value={row.info_wall_text} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="info_wall_text" placeholder={""} className=' w400  h100' req='1' firstUp="0" />
                                                                        </div>
                                                                </Fragment>
                                                            }
                                            </div>

                                    <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>dodaj</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                    </div>

                            </div>
    }
        





        return <div>


                    <div className="table_filter">

                        <div className="filter_controll">   
                            <label>Dzień: </label>                             
                            <InputDate   userData={props.userData}  mainView={props.mainView}   value={filterParam.dzien}   valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={"Dzień: "}     />
                        </div>

                        <div className="filter_btn">                           
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                    </div>


                      <div className="table_widget">                               

                            {
                                 props.status == "aktywny" &&
                                <div className="btn" onClick={changeView} v="new" id="-1"  > zaplanuj spotkanie</div>
                            }                           

                            &nbsp;&nbsp;  
                            &nbsp;&nbsp;  
                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={props.title  } />  
                      </div>


                    <div ref={tabRef} className="gohide">
                        <h3>{props.title}, spotkania z rodzicami</h3>   

                        
                          <table className="table plan_d" >
                                    {
                                        tab.map( (item, ix) => {


                                                return <Fragment>

                                                        
                                                            <tr>
                                                                        <td className="title" style={{fontWeight:"bold"}}>
                                                                           {item.dzien} {item.godzina.substring(0,5)}, {item.tytul}
                                                                        </td>                                                                                                                                                                                                                     
                                                                </tr>

                                                                <tr>
                                                                    <td colSpan={2} className="borderBottomLine">
                                                                        {item.opis}
                                                                        <br/>&nbsp;
                                                                    </td>                                                   
                                                                </tr>     

                                                </Fragment>

                                        } )
                                    }
                                </table>


                    </div>



                          <div className="scorll_x">
          

                               <table className="table plan_d" >
                                    {
                                        tab.map( (item, ix) => {


                                                return <Fragment>

                                                        
                                                            <tr>
                                                                        <td className="title">
                                                                            {item.tytul}
                                                                        </td>
                                                                        <td className="hour">
                                                                            {item.dzien} {item.godzina.substring(0,5)}
                                                                        </td>                                                                       
                                                                        <td rowSpan={2}>
                                                                            <MenuTable>
                                                                                        <ul>                                                                      
                                                                                            {
                                                                                                props.status == "aktywny" &&
                                                                                                <li onClick={deleteRecord}  id={item.id}  >usuń</li>  
                                                                                            }
                                                                                               
                                                                                        </ul>                                                               
                                                                            </MenuTable>  

                                                                        </td>
                                                                </tr>

                                                                <tr>
                                                                    <td colSpan={2} className="borderBottomLine">
                                                                        {item.opis}
                                                                        <br/>&nbsp;
                                                                    </td>                                                   
                                                                </tr>     

                                                </Fragment>

                                        } )
                                    }
                                </table>
             </div>
             
            {viewDialog}

        </div>
}